import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Components/Navbar'
import BalancePayment from '../Components/BalancePayment'
import '../Styles/MakePayment.scss'

// Paying outstanding balances, on its own page rather than tucked under the dashboard list.
//
// The dashboard links here when anything is owed. All the logic lives in BalancePayment, which
// talks to the same /cart/balance endpoints the cart's checkout uses — the only difference is that
// its lines are existing registrations instead of cart items.
function MakePayment() {
   return (
      <div>
         <div className="NavBar">
            <Navbar />
         </div>

         <div className="MakePaymentContent">
            <div className="MakePaymentContainer">
               <div className="MakePaymentBackLink">
                  <Link to="/individualaccount">← Back to my account</Link>
               </div>
               <BalancePayment />
            </div>
         </div>
      </div>
   )
}

export default MakePayment
